import React from "react";

const dims = [
  { key: "business", label: "Business" },
  { key: "customer", label: "Customer" },
  { key: "decision", label: "Decision" },
  { key: "market", label: "Market" },
  { key: "starting_condition", label: "Starting condition" },
];

function barColor(v) {
  if (v >= 75) return "bg-emerald-500";
  if (v >= 50) return "bg-amber-500";
  return "bg-rose-500";
}

export function SimilarityBars({ similarity, compact }) {
  if (!similarity) return null;
  return (
    <div className="space-y-2.5">
      {dims.map((d) => {
        const v = similarity[d.key] ?? 0;
        return (
          <div key={d.key} className="flex items-center gap-3">
            <span className="text-xs text-slate-500 w-32 shrink-0">{d.label}</span>
            <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
              <div className={`h-full rounded-full ${barColor(v)}`} style={{ width: `${v}%` }} />
            </div>
            <span className="font-mono text-xs text-slate-700 w-8 text-right">{v}</span>
          </div>
        );
      })}
      {!compact && similarity.rationale && (
        <p className="text-xs text-slate-500 leading-relaxed pt-1">{similarity.rationale}</p>
      )}
    </div>
  );
}

export function ScoreRing({ value }) {
  const v = value ?? 0;
  const color = v >= 75 ? "#059669" : v >= 50 ? "#d97706" : "#e11d48";
  const r = 26, c = 2 * Math.PI * r;
  return (
    <div className="relative w-16 h-16 shrink-0">
      <svg width="64" height="64" className="-rotate-90">
        <circle cx="32" cy="32" r={r} stroke="#f1f5f9" strokeWidth="6" fill="none" />
        <circle cx="32" cy="32" r={r} stroke={color} strokeWidth="6" fill="none"
          strokeDasharray={c} strokeDashoffset={c - (v / 100) * c} strokeLinecap="round" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="font-mono text-sm font-semibold text-slate-900">{v}</span>
      </div>
    </div>
  );
}
